// extracted by mini-css-extract-plugin
module.exports = {"total_sales_card_group":"TotalSales_total_sales_card_group__GD9Fo","card_text_content":"TotalSales_card_text_content__1RxAF"};